export const GET_MEMBERS_REQUEST = 'GET_MEMBERS_REQUEST';
export const GET_MEMBERS_SUCCESS = 'GET_MEMBERS_SUCCESS';
export const GET_MEMBERS_FAILED = 'GET_MEMBERS_FAILED';

export const ADD_MEMBER_REQUEST = 'ADD_MEMBER_REQUEST';
export const ADD_MEMBER_SUCCESS = 'ADD_MEMBER_SUCCESS';
export const ADD_MEMBER_FAILED = 'ADD_MEMBER_FAILED';

export const UPDATE_MEMBER_REQUEST = 'UPDATE_MEMBER_REQUEST';
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS';
export const UPDATE_MEMBER_FAILED = 'UPDATE_MEMBER_FAILED';

export const DELETE_MEBMER_REQUEST = 'DELETE_MEMBER_REQUEST';
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS';
export const DELETE_MEMBER_FAILED = 'DELETE_MEMBER_FAILED';

export const ADD_PLANS_TO_MEMBER_REQUEST = 'ADD_PLANS_TO_MEMBER_REQUEST';
export const ADD_PLANS_TO_MEMBER_SUCCESS = 'ADD_PLANS_TO_MEMBER_SUCCESS';
export const ADD_PLANS_TO_MEMBER_FAILED = 'ADD_PLANS_TO_MEMBER_FAILED';

export const UPDATE_MEMBERS_MEMBERSHIP_PLAN_REQUEST = 'UPDATE_MEMBERS_MEMBERSHIP_PLAN_REQUEST';
export const UPDATE_MEMBERS_MEMBERSHIP_PLAN_SUCCESS = 'UPDATE_MEMBERS_MEMBERSHIP_PLAN_SUCCESS';
export const UPDATE_MEMBERS_MEMBERSHIP_PLAN_FAILED = 'UPDATE_MEMBERS_MEMBERSHIP_PLAN_FAILED';

export const GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_REQUEST = 'GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_REQUEST';
export const GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_SUCCESS = 'GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_SUCCESS';
export const GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_FAILED = 'GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_FAILED';

export const INVITE_MEMBER_BY_EMAIL_REQUEST = 'INVITE_MEMBER_BY_EMAIL_REQUEST';
export const INVITE_MEMBER_BY_EMAIL_SUCCESS = 'INVITE_MEMBER_BY_EMAIL_SUCCESS';
export const INVITE_MEMBER_BY_EMAIL_FAILED = 'INVITE_MEMBER_BY_EMAIL_FAILED';

export const GET_WAITING_MEMBERS_REQUEST = 'GET_WAITING_MEMBERS_REQUEST';
export const GET_WAITING_MEMBERS_SUCCESS = 'GET_WAITING_MEMBERS_SUCCESS';
export const GET_WAITING_MEMBERS_FAILED = 'GET_WAITING_MEMBERS_FAILED';

export const GET_CLASSES_FOR_PLANS_REQUEST = 'GET_CLASSES_FOR_PLANS_REQUEST';
export const GET_CLASSES_FOR_PLANS_SUCCESS = 'GET_CLASSES_FOR_PLANS_SUCCESS';
export const GET_CLASSES_FOR_PLANS_FAILED = 'GET_CLASSES_FOR_PLANS_FAILED';

export const ASSIGN_CLASSES_TO_PLAN_REQUEST = 'ASSIGN_CLASSES_TO_PLAN_REQUEST';
export const ASSIGN_CLASSES_TO_PLAN_SUCCESS = 'ASSIGN_CLASSES_TO_PLAN_SUCCESS';
export const ASSIGN_CLASSES_TO_PLAN_FAILED = 'ASSIGN_CLASSES_TO_PLAN_FAILED';

export const RESEND_MEMBER_INVITATION_REQUEST = 'RESEND_MEMBER_INVITATION_REQUEST';
export const RESEND_MEMBER_INVITATION_SUCCESS = 'RESEND_MEMBER_INVITATION_SUCCESS';
export const RESEND_MEMBER_INVITATION_FAILED = 'RESEND_MEMBER_INVITATION_FAILED';

export const UPDATE_MEMBER_STATUS_REQUEST = 'UPDATE_MEMBER_STATUS_REQUEST';
export const UPDATE_MEMBER_STATUS_SUCCESS = 'UPDATE_MEMBER_STATUS_SUCCESS';
export const UPDATE_MEMBER_STATUS_FAILED = 'UPDATE_MEMBER_STATUS_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/MembersActionTypes.js